import { BlogPostTile, ToolTile } from '@/components/content-tiles';
import DiscussionTile from '@/components/content-tiles/DiscussionTile/DiscussionTile';
import { ContentType } from '@/common/constants/ContentTypes';
import { ProductTile } from '@/widgets/product';
import { Product } from '@/types/Content/Product/Product';

export function Tile(props: { [x: string]: any }): JSX.Element {
  switch (props?.contentType || props.resourceType?.type) {
    case ContentType.PRODUCTS:
    case ContentType.AFFILIATE_PRODUCT:
      return (
        <ProductTile
          product={props as Product}
          villageId={props.villageId}
          bgColor={props?.bgColor}
          className={props?.className}
        />
      );

    case ContentType.ARTICLE:
    case ContentType.RLS:
    case ContentType.VIDEO:
      return (
        <BlogPostTile
          slug={props.slug}
          title={props.title}
          image={props.image}
          resourceType={props.resourceType}
          bgColor={props?.bgColor}
          className={props?.className}
        />
      );

    case ContentType.DISCUSSIONS:
      return (
        <DiscussionTile
          slug={props.slug}
          content={props.title}
          author={props.author}
          bgColor={props?.bgColor}
          className={props?.className}
        />
      );

    case 'tool':
      return (
        <ToolTile
          tool={props}
          bgColor={props?.bgColor}
          className={props?.className}
        />
      );

    default:
      return <></>;
  }
}
